export const translations = {
  en: {
    brand: "M&D Realtors",
    nav: {
      buy: "Buy", rent: "Rent", sell: "Sell", neighborhoods: "Neighborhoods",
      agents: "Agents", journal: "Journal", contact: "Contact", virtualTour: "Virtual Tour",
      signin: "Sign In", dashboard: "Dashboard", logout: "Log Out",
    },
    common: {
      search: "Search", viewAll: "View All", viewDetails: "View Details",
      readMore: "Read More", learnMore: "Learn More", submit: "Submit",
      loading: "Loading…", from: "From", perMonth: "/mo", bed: "bd", bath: "ba",
      sqft: "sqft", featured: "Featured", forSale: "For Sale", forRent: "For Rent",
      sold: "Sold", rented: "Rented", noResults: "No properties match your search.",
      save: "Save", saved: "Saved", cancel: "Cancel", close: "Close", all: "All",
      scheduleTour: "Schedule a Tour", requestInfo: "Request Info", call: "Call",
      backToListings: "Back to listings", similar: "Similar Properties",
      email: "Email", phone: "Phone", name: "Name", message: "Message",
      sending: "Sending…", price: "Price", any: "Any",
    },
    hero: {
      tag: "Contemporary Luxury Real Estate",
      title: "Find where your next chapter begins",
      subtitle: "Curated luxury homes, waterfront estates, and investment properties across South Florida — guided by advisors who understand extraordinary living.",
      searchPlaceholder: "City, neighborhood, or ZIP code",
    },
    search: {
      buy: "Buy", rent: "Rent", type: "Property Type", price: "Price Range",
      beds: "Beds", baths: "Baths", minSqft: "Min Sqft", amenities: "Amenities",
      status: "Status", moreFilters: "More Filters", clear: "Clear", results: "Results",
      sortBy: "Sort by", recent: "Most Recent", priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low", grid: "Grid", list: "List", map: "Map",
      minPrice: "Min Price", maxPrice: "Max Price", city: "City",
    },
    home: {
      featuredTag: "Handpicked Collection", featuredTitle: "Featured Residences",
      featuredSub: "A selection of our most extraordinary listings, chosen for their architecture, location, and rarity.",
      exploreTag: "Explore", exploreTitle: "Browse by Lifestyle",
      neighborhoodsTag: "Locations", neighborhoodsTitle: "Iconic Neighborhoods",
      neighborhoodsSub: "Discover the areas that define South Florida living.",
      statsTitle: "A track record of trust",
      whyTag: "The M&D Realtors Difference", whyTitle: "White-glove service, end to end",
      testimonialsTitle: "Loved by our clients",
      ctaTitle: "Ready to make your move?",
      ctaSub: "Whether buying, selling, or investing — our advisors are ready to guide you.",
      journalTag: "Insights", journalTitle: "From the Journal",
    },
    lifestyle: {
      buyer: "For Buyers", buyerDesc: "Find your dream home",
      seller: "For Sellers", sellerDesc: "Sell for top value",
      renter: "For Renters", renterDesc: "Premium rentals",
      investor: "For Investors", investorDesc: "Grow your portfolio",
    },
    stats: { properties: "Listings", sales: "In Sales", clients: "Happy Clients", agents: "Expert Advisors" },
    why: {
      f1: "Bespoke Search", f1d: "Every recommendation tailored to your lifestyle and goals.",
      f2: "Global Reach", f2d: "Multilingual advisors serving buyers from around the world.",
      f3: "Cinematic Marketing", f3d: "World-class photography, video, and virtual tours.",
      f4: "Trusted Guidance", f4d: "Data-driven advice at every step of your journey.",
    },
    detail: {
      overview: "Overview", features: "Features & Amenities", location: "Location",
      floorPlan: "Floor Plan", virtualTour: "360° Virtual Tour", video: "Video Tour",
      details: "Property Details", type: "Type", built: "Year Built", lot: "Lot Size",
      parking: "Parking", status: "Status", agent: "Your Advisor",
      relatedCosts: "Estimated Monthly Costs", mortgage: "Est. Mortgage",
      contactAgent: "Contact Advisor", whatsapp: "WhatsApp",
    },
    auth: {
      signin: "Sign In", signup: "Create Account", welcome: "Welcome back",
      welcomeSub: "Sign in to access your dashboard, favorites, and saved searches.",
      joinTitle: "Join M&D Realtors", joinSub: "Create your account to save homes and get personalized alerts.",
      email: "Email", password: "Password", name: "Full Name", phone: "Phone",
      role: "I am a", noAccount: "Don't have an account?", haveAccount: "Already have an account?",
      forgot: "Forgot password?", roleClient: "Buyer / Renter", roleOwner: "Property Owner",
      roleAgent: "Agent", roleReferral: "Referral Partner", signingIn: "Signing in…",
    },
    dash: {
      overview: "Overview", favorites: "Favorites", savedSearches: "Saved Searches",
      appointments: "Appointments", profile: "Profile", listings: "Listings",
      leads: "Leads", users: "Users", media: "Media Library", import: "Import",
      audit: "Audit Log", analytics: "Analytics", settings: "Settings",
      welcome: "Welcome back", myProperties: "My Properties",
      activeListings: "Active Listings", newLeads: "New Leads", upcoming: "Upcoming Tours",
      conversion: "Conversion Rate", totalViews: "Total Views", sold: "Sold", totalUsers: "Users",
      recentActivity: "Recent Activity", topProperties: "Most Viewed", leadsBySource: "Leads by Source",
      leadsByStage: "Pipeline", addListing: "Add Listing", noFavorites: "You haven't saved any homes yet.",
      noAppointments: "No appointments scheduled.", pipeline: "Lead Pipeline",
    },
    footer: {
      tagline: "Contemporary luxury real estate, redefined.",
      explore: "Explore", company: "Company", legal: "Legal",
      about: "About Us", careers: "Careers", press: "Press",
      privacy: "Privacy Policy", terms: "Terms", rights: "All rights reserved.",
      newsletter: "Get new listings first", subscribe: "Subscribe",
    },
    chat: {
      title: "Aria — Concierge", subtitle: "M&D Realtors assistant",
      placeholder: "Ask about homes, neighborhoods…", greeting: "Hi there, I'm Aria from M&D Realtors! So glad you stopped by. I'm here to help you by chat — find homes, answer your questions, or schedule a visit with our team. You can turn on my voice anytime with the speaker button above. How can I help you today?",
      s1: "Homes under $1M", s2: "Waterfront villas", s3: "Pet-friendly rentals", s4: "Schedule a tour",
    },
  },
  es: {
    brand: "M&D Realtors",
    nav: {
      buy: "Comprar", rent: "Alquilar", sell: "Vender", neighborhoods: "Barrios",
      agents: "Agentes", journal: "Revista", contact: "Contacto", virtualTour: "Tour Virtual",
      signin: "Ingresar", dashboard: "Panel", logout: "Salir",
    },
    common: {
      search: "Buscar", viewAll: "Ver Todo", viewDetails: "Ver Detalles",
      readMore: "Leer Más", learnMore: "Saber Más", submit: "Enviar",
      loading: "Cargando…", from: "Desde", perMonth: "/mes", bed: "hab", bath: "baños",
      sqft: "pies²", featured: "Destacado", forSale: "En Venta", forRent: "En Alquiler",
      sold: "Vendido", rented: "Alquilado", noResults: "Ninguna propiedad coincide con tu búsqueda.",
      save: "Guardar", saved: "Guardado", cancel: "Cancelar", close: "Cerrar", all: "Todo",
      scheduleTour: "Agendar Visita", requestInfo: "Solicitar Info", call: "Llamar",
      backToListings: "Volver a listados", similar: "Propiedades Similares",
      email: "Correo", phone: "Teléfono", name: "Nombre", message: "Mensaje",
      sending: "Enviando…", price: "Precio", any: "Cualquiera",
    },
    hero: {
      tag: "Bienes Raíces de Lujo Contemporáneo",
      title: "Encuentra dónde comienza tu próximo capítulo",
      subtitle: "Casas de lujo, propiedades frente al mar e inversiones seleccionadas en el sur de Florida — guiado por asesores que entienden el vivir extraordinario.",
      searchPlaceholder: "Ciudad, barrio o código postal",
    },
    search: {
      buy: "Comprar", rent: "Alquilar", type: "Tipo de Propiedad", price: "Rango de Precio",
      beds: "Habitaciones", baths: "Baños", minSqft: "Pies² Mín", amenities: "Amenidades",
      status: "Estado", moreFilters: "Más Filtros", clear: "Limpiar", results: "Resultados",
      sortBy: "Ordenar por", recent: "Más Recientes", priceAsc: "Precio: Menor a Mayor",
      priceDesc: "Precio: Mayor a Menor", grid: "Cuadrícula", list: "Lista", map: "Mapa",
      minPrice: "Precio Mín", maxPrice: "Precio Máx", city: "Ciudad",
    },
    home: {
      featuredTag: "Colección Seleccionada", featuredTitle: "Residencias Destacadas",
      featuredSub: "Una selección de nuestros listados más extraordinarios, elegidos por su arquitectura, ubicación y exclusividad.",
      exploreTag: "Explorar", exploreTitle: "Explora por Estilo de Vida",
      neighborhoodsTag: "Ubicaciones", neighborhoodsTitle: "Barrios Icónicos",
      neighborhoodsSub: "Descubre las zonas que definen el vivir del sur de Florida.",
      statsTitle: "Una trayectoria de confianza",
      whyTag: "La Diferencia M&D Realtors", whyTitle: "Servicio impecable, de principio a fin",
      testimonialsTitle: "Amado por nuestros clientes",
      ctaTitle: "¿Listo para dar el paso?",
      ctaSub: "Ya sea comprando, vendiendo o invirtiendo, nuestros asesores están listos para guiarte.",
      journalTag: "Perspectivas", journalTitle: "De la Revista",
    },
    lifestyle: {
      buyer: "Compradores", buyerDesc: "Encuentra tu hogar ideal",
      seller: "Vendedores", sellerDesc: "Vende al mejor valor",
      renter: "Inquilinos", renterDesc: "Alquileres premium",
      investor: "Inversores", investorDesc: "Haz crecer tu portafolio",
    },
    stats: { properties: "Listados", sales: "En Ventas", clients: "Clientes Felices", agents: "Asesores Expertos" },
    why: {
      f1: "Búsqueda a Medida", f1d: "Cada recomendación adaptada a tu estilo de vida y metas.",
      f2: "Alcance Global", f2d: "Asesores multilingües que atienden compradores de todo el mundo.",
      f3: "Marketing Cinematográfico", f3d: "Fotografía, video y tours virtuales de clase mundial.",
      f4: "Guía de Confianza", f4d: "Asesoría basada en datos en cada paso de tu camino.",
    },
    detail: {
      overview: "Descripción", features: "Características y Amenidades", location: "Ubicación",
      floorPlan: "Plano", virtualTour: "Tour Virtual 360°", video: "Video Tour",
      details: "Detalles de la Propiedad", type: "Tipo", built: "Año de Construcción", lot: "Tamaño del Lote",
      parking: "Estacionamiento", status: "Estado", agent: "Tu Asesor",
      relatedCosts: "Costos Mensuales Estimados", mortgage: "Hipoteca Est.",
      contactAgent: "Contactar Asesor", whatsapp: "WhatsApp",
    },
    auth: {
      signin: "Ingresar", signup: "Crear Cuenta", welcome: "Bienvenido de nuevo",
      welcomeSub: "Ingresa para acceder a tu panel, favoritos y búsquedas guardadas.",
      joinTitle: "Únete a M&D Realtors", joinSub: "Crea tu cuenta para guardar casas y recibir alertas personalizadas.",
      email: "Correo", password: "Contraseña", name: "Nombre Completo", phone: "Teléfono",
      role: "Soy", noAccount: "¿No tienes cuenta?", haveAccount: "¿Ya tienes cuenta?",
      forgot: "¿Olvidaste tu contraseña?", roleClient: "Comprador / Inquilino", roleOwner: "Propietario",
      roleAgent: "Agente", roleReferral: "Socio de Referidos", signingIn: "Ingresando…",
    },
    dash: {
      overview: "Resumen", favorites: "Favoritos", savedSearches: "Búsquedas Guardadas",
      appointments: "Citas", profile: "Perfil", listings: "Listados",
      leads: "Prospectos", users: "Usuarios", media: "Biblioteca de Medios", import: "Importar",
      audit: "Registro de Auditoría", analytics: "Analíticas", settings: "Ajustes",
      welcome: "Bienvenido de nuevo", myProperties: "Mis Propiedades",
      activeListings: "Listados Activos", newLeads: "Nuevos Prospectos", upcoming: "Próximas Visitas",
      conversion: "Tasa de Conversión", totalViews: "Vistas Totales", sold: "Vendidos", totalUsers: "Usuarios",
      recentActivity: "Actividad Reciente", topProperties: "Más Vistas", leadsBySource: "Prospectos por Fuente",
      leadsByStage: "Embudo", addListing: "Agregar Listado", noFavorites: "Aún no has guardado ninguna casa.",
      noAppointments: "No hay citas programadas.", pipeline: "Embudo de Prospectos",
    },
    footer: {
      tagline: "Bienes raíces de lujo contemporáneo, redefinidos.",
      explore: "Explorar", company: "Empresa", legal: "Legal",
      about: "Nosotros", careers: "Carreras", press: "Prensa",
      privacy: "Privacidad", terms: "Términos", rights: "Todos los derechos reservados.",
      newsletter: "Recibe listados nuevos primero", subscribe: "Suscribir",
    },
    chat: {
      title: "Aria — Concierge", subtitle: "Asistente de M&D Realtors",
      placeholder: "Pregunta sobre casas, barrios…", greeting: "¡Hola! Soy Aria, de M&D Realtors. Qué gusto tenerte por aquí. Estoy para ayudarte por chat — buscar propiedades, resolver tus dudas o agendar una visita con nuestro equipo. Si quieres, puedes activar mi voz con el botón de la bocina de arriba. ¿En qué te puedo ayudar hoy?",
      s1: "Casas bajo $1M", s2: "Villas frente al mar", s3: "Alquileres que aceptan mascotas", s4: "Agendar una visita",
    },
  },
};
